import React, { useEffect, useState } from "react";
import {
  apiCallResponse,
  apiCallSP,
  apiCallSPGet,
} from "src/_apiConfig/apiCall";
import { useHistory } from "react-router-dom";
import Auth from "src/auth";
import {
  addToastError,
  addToastSuccess,
  AlertResponse,
} from "src/_constants/alert.type";
import ToastMessage from "src/_components/ToastMessage";
import { updateSearchStatus } from "src/views/common/CommonSearch";
import {
  CButton,
  CCardHeader,
  CCol,
  CForm,
  CInput,
  CInvalidFeedback,
  CLabel,
  CRow,
  CSelect,
  CSpinner,
} from "@coreui/react";
import { isValidDate } from "src/views/common/Common";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

// import usersData from "../users/UsersData";
const GoDownFeesExtensionEdit = () => {
  // const { addToast } = useToast();

  const history = useHistory();
  let { id } = useParams();
  const [loading, setloading] = useState(false);

  const { authenticated } = Auth();

  const [submitted, setSubmitted] = useState(false);
  const [toasts, setToasts] = useState(AlertResponse);

  const params = {
    tenderId: "",
    lotId: 0,
    amount: "",
    startDate: "",
    endDate: "",
  };
  const [addParam, setAddParam] = useState(params);
  useEffect(() => {
    getGoDownRentFeeExtension(id);
    getTenderNo();
    getLotNoByTenderId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  const [validated, setValidated] = useState(false);

  const [itemsTenderNo, setItemsTenderNo] = useState([]);
  const [itemsLotNo, setItemsLotNo] = useState([]);

  // Search Model Value Update Manage
  const updateParam = (e, name = "", value = "") => {
    updateSearchStatus(setAddParam, addParam, e, name, value);
  };

  const formatDate = (item) => {
    if (item != null) {
      item = item.split("T")[0];
      const day = item.substring(8, 10);
      const month = item.substring(5, 7);
      const year = item.substring(0, 4);
      return `${year}-${month}-${day}`;
    }
  };

  const getGoDownRentFeeExtension = async (id) => {
    if (authenticated) {
      setloading(true);
      await apiCallSPGet(`GoDownRentFeeExtension/SelectById?Id=${id}`).then(
        (res) => {
          if (res.success) {
            console.log("getRoleDetails", res.data);
            const gd = res.data;
            setAddParam({
              ...addParam,
              tenderId: gd.tenderId,
              lotId: gd.lotId,
              amount: gd.amount,
              startDate: formatDate(gd.startDate),
              endDate: formatDate(gd.endDate),
            });
          }
          setloading(false);
        }
      );
    }
  };
  const getTenderNo = async (tenderCollectionSeasonSearch = "") => {
    if (authenticated) {
      let filter = "";
      filter = "&$filter=districtId eq " + authenticated.district;

      if (
        tenderCollectionSeasonSearch !== "" &&
        tenderCollectionSeasonSearch !== undefined
      ) {
        filter +=
          " and contains(collectionSeason,'" +
          tenderCollectionSeasonSearch +
          "')";
      }
      await apiCallResponse(
        `Tender/GetTenderByDistrictId?$orderBy=tenderNo%20desc${filter}`
      ).then((res) => {
        if (res.success) {
          setItemsTenderNo(
            res.data.length
              ? [
                  ...new Map(
                    res.data.map((tender) => [tender.tenderId, tender])
                  ).values(),
                ]
              : []
          );
        } else setItemsTenderNo([]);
      });
    }
  };
  const getLotNoByTenderId = async (tenderId = 0) => {
    if (authenticated) {
      let filter = "";
      filter = "&$filter=districtId eq " + authenticated.district;

      if (tenderId !== 0 && tenderId !== undefined) {
        filter += "and tenderId eq " + tenderId;
      }
      //const url = `LotDetails/getLotByTenderId?$orderBy=lotNo%20asc${filter}`;
      const url = `LotDetails/getLotByTenderId?${filter}`;
      await apiCallResponse(url).then((res) => {
        console.log("getLotNoByTenderId ", res);
        if (res.success) setItemsLotNo(res.data);
        else setItemsLotNo([]);
      });
    }
  };

  const handleChangeLotTender = (e) => {
    const value = e.target.value;
    updateParam(e, "lotId", 0);
    setItemsLotNo([]);
    getLotNoByTenderId(value);
  };

  const AmountValidation = (amount) => {
    const numericAmount = Number(amount);

    if (
      isNaN(amount) || // Check if amount is NaN
      amount === "" || // Check if amount is empty
      amount.endsWith(".") || // Check if amount ends with a dot
      numericAmount === 0 || // Check if amount is exactly zero
      numericAmount < 1 || // Check if amount is less than 1
      numericAmount <= 0 // Check if amount is less than or equal to zero

      //!/^[1-9]\d*$/.test(amount) // Check if amount doesn't start with a non-zero digit
    ) {
      return true;
    }

    return false;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    //setSubmitted(true);
    setloading(true);
    const form = event.currentTarget;

    if (
      form.checkValidity() === false ||
      addParam.startDate === "" ||
      addParam.endDate === "" ||
      AmountValidation(addParam.amount)
    ) {
      setSubmitted(true);

      //event.stopPropagation();
    } else {
      const data = JSON.stringify({
        id: parseInt(id),
        lotId: addParam.lotId,
        amount: addParam.amount,
        startDate: addParam.startDate,
        endDate: addParam.endDate,
        insertedBy: authenticated.userId,
      });
      setloading(false);

      await apiCallSP("GoDownRentFeeExtension/Update", "PUT", {}, data).then(
        async (res) => {
          if (res.success) {
            setAddParam({ ...addParam, ...params });
            addToastSuccess(setToasts, res.message);
            history.push("/GoDownFeesExtension/List");
          } else {
            addToastError(setToasts, res.message);
          }

          setloading(false);
        }
      );

      //alert("data Submite");
    }

    setValidated(true);
    setloading(false);
  };

  // Function to handle date changes
  const handleDateChange = (event) => {
    console.log("handleDateChange", event);
    const inputDate = event.target.value;

    // Check if the input date is not empty and if it is valid
    if (inputDate.trim() !== "" && !isValidDate(inputDate)) {
      // Handle invalid date input, such as showing an error message
      addToastError(setToasts, "Invalid date format", 0);
      // Reset the input value
      event.target.value = "";
    } else {
      updateParam(event); // or whatever function you need to call when the date changes
    }
  };
  return (
    <>
      <ToastMessage toasts={toasts} setToasts={setToasts} />
      <CCardHeader>
        <CRow xl={12} className="pt-3 ">
          <CCol xl={10}>
            <h3>GoDown Fees Extension - Edit Request</h3>
          </CCol>
        </CRow>
      </CCardHeader>

      <CForm
        onSubmit={handleSubmit}
        noValidate
        validated={validated}
        className="was-validation"
      >
        <CRow className="mb-3 ml-1 mt-2">
          <CCol xl={3} sm={6}>
            <CLabel>Select Tender Number * : </CLabel>
            <CSelect
              required
              aria-label="Default select example"
              name="tenderNo"
              value={addParam.tenderId}
              onChange={handleChangeLotTender}
              id="validationCustom01"
              invalid={submitted && addParam.tenderNo === ""}
              aria-describedby="validationCustom01TenderNumber"
              disabled
            >
              <option value="">Select Tender Number</option>
              {itemsTenderNo?.map((item, key) => (
                <option key={key} value={item.tenderId}>
                  {item.tenderNo}
                </option>
              ))}
            </CSelect>
            <CInvalidFeedback className="validationCustom01">
              Please Select Tender Number
            </CInvalidFeedback>
          </CCol>
          <CCol xl={3} sm={6}>
            <CLabel>Select Lot Number * : </CLabel>
            <CSelect
              required
              aria-label="Default select example"
              name="lotId"
              value={addParam.lotId}
              onChange={updateParam}
              id="validationCustom02"
              invalid={submitted && Number(addParam.lotId) === 0}
              aria-describedby="validationCustom02LotNumber"
              disabled
            >
              <option value="">Select Lot Number</option>
              {itemsLotNo?.map((item, key) => (
                <option key={key} value={item.lotId}>
                  {item.lotNo}
                </option>
              ))}
            </CSelect>
            <CInvalidFeedback className="validationCustom02">
              Please Select Lot Number
            </CInvalidFeedback>
          </CCol>
          <CCol xl={3} sm={6}>
            <CLabel> Amount * : </CLabel>
            <CInput
              required
              type="text"
              name="amount"
              value={addParam.amount}
              onChange={updateParam}
              invalid={submitted && AmountValidation(addParam.amount)}
              id="validationCustom03"
              aria-describedby="validationCustom03Feedback"
            />
            <CInvalidFeedback className="validationCustom03">
              Please enter a valid amount greater than zero
            </CInvalidFeedback>
          </CCol>
          <CCol xl={3} sm={6}>
            <CLabel>Start Date * :</CLabel>
            <CInput
              type="date"
              placeholder=""
              name="startDate"
              defaultValue={addParam.startDate}
              onChange={handleDateChange}
              invalid={submitted && addParam.startDate === ""}
              id="validationCustom04"
              aria-describedby="validationCustom04StartDate"
            />
            <CInvalidFeedback className="validationCustom04">
              Please enter a valid Start Date
            </CInvalidFeedback>
          </CCol>

          <CCol xl={3} sm={6}>
            <CLabel>End Date * :</CLabel>
            <CInput
              type="date"
              placeholder=""
              name="endDate"
              value={addParam.endDate}
              onChange={handleDateChange}
              invalid={
                submitted &&
                (addParam.endDate === "" ||
                  new Date(addParam.startDate) > new Date(addParam.endDate))
              }
              id="validationCustom05"
              aria-describedby="validationCustom05EndDate"
              min={addParam.startDate}
            />
            <CInvalidFeedback className="validationCustom05">
              {addParam.endDate === "" || addParam.endDate === null
                ? "Please enter a valid End Date"
                : new Date(addParam.startDate) > new Date(addParam.endDate)
                ? "The Start Date cannot be earlier than the End Date."
                : ""}
            </CInvalidFeedback>
          </CCol>
        </CRow>
        <CRow className={"ml-1"}>
          <CCol></CCol>
        </CRow>
        <CRow className="mb-2 ml-4 mt-2">
          {loading ? (
            <CSpinner className="spinner-grow" color="success" variant="grow" />
          ) : (
            <>
              <CButton type="submit" color="success">
                Update
              </CButton>

              <CButton
                color="danger"
                className="ml-2"
                to="/GoDownFeesExtension/List"
              >
                Cancel
              </CButton>
            </>
          )}
        </CRow>
      </CForm>
    </>
  );
};
export default GoDownFeesExtensionEdit;
